/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowTaskDto } from './WorkflowTaskDto';
import {
    WorkflowTaskDtoFromJSON,
    WorkflowTaskDtoFromJSONTyped,
    WorkflowTaskDtoToJSON,
} from './WorkflowTaskDto';

/**
 * 
 * @export
 * @interface WorkflowModelDto
 */
export interface WorkflowModelDto {
    /**
     * Name of workflow model
     * @type {string}
     * @memberof WorkflowModelDto
     */
    id: string;
    /**
     * Version of workflow model. There can be several versions for one model, all of them should be supported by system
     * @type {number}
     * @memberof WorkflowModelDto
     */
    version: number;
    /**
     * Workflow model name. The same as workflow model id or its localized version
     * @type {string}
     * @memberof WorkflowModelDto
     */
    name?: string;
    /**
     * Purpose description in human-readable form
     * @type {string}
     * @memberof WorkflowModelDto
     */
    purposeStatement?: string;
    /**
     * Can be used to start new workflow instances
     * @type {boolean}
     * @memberof WorkflowModelDto
     */
    isActive?: boolean;
    /**
     * Any additional workflow model parameters
     * @type {{ [key: string]: string; }}
     * @memberof WorkflowModelDto
     */
    parameters?: { [key: string]: string; };
    /**
     * 
     * @type {Array<WorkflowTaskDto>}
     * @memberof WorkflowModelDto
     */
    tasks?: Array<WorkflowTaskDto>;
}

/**
 * Check if a given object implements the WorkflowModelDto interface.
 */
export function instanceOfWorkflowModelDto(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('version' in value)) return false;
    return true;
}

export function WorkflowModelDtoFromJSON(json: any): WorkflowModelDto {
    return WorkflowModelDtoFromJSONTyped(json, false);
}

export function WorkflowModelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowModelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'version': json['version'],
        'name': json['name'] == null ? undefined : json['name'],
        'purposeStatement': json['purposeStatement'] == null ? undefined : json['purposeStatement'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(WorkflowTaskDtoFromJSON)),
    };
}

export function WorkflowModelDtoToJSON(value?: WorkflowModelDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'version': value['version'],
        'name': value['name'],
        'purposeStatement': value['purposeStatement'],
        'isActive': value['isActive'],
        'parameters': value['parameters'],
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(WorkflowTaskDtoToJSON)),
    };
}

